import '../utilities/scrollspy.js'; // https://github.com/r3plica/Scrollspy

$ = window.jQuery;

const s = {
  navbar: document.getElementById('navbar'),
}

function init() {
  if (document.body.contains(s.navbar)) {
    let navbarOffset = s.navbar.getBoundingClientRect().top + window.scrollY;

    stickyNavbar(navbarOffset);

    window.addEventListener('scroll', function() {
      stickyNavbar(navbarOffset);
    });

    $(s.navbar).scrollspy({
      offset: 60
    });
  }
}

function stickyNavbar(navbarOffset) {
  if (window.scrollY >= navbarOffset) {
    s.navbar.classList.add("sticky");
  } else {
    s.navbar.classList.remove("sticky");
  }
}

export { init as default }
